export default class Translator {
    translations = {};
    domain = '';

    constructor(translations, domain) {
        this.translations = translations;
        this.domain = domain;
    }

    /**
     * Translates for the given key.
     * If data provided, it interpolates variables inside translation string
     * data variable example: [{key: 'myKey', value: 'myValue'}]
     */
    trans(key, data) {
        if (this.translations[this.domain] === undefined || this.translations[this.domain][key] === undefined) {
            return key;
        }

        let translation = this.translations[this.domain][key];
        if (data !== undefined && data.length > 0) {
            for(let i = 0; i < data.length; i++) {
                translation = translation.replace(data[i].key, data[i].value);
            }
        }

        return translation;
    }

    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/Translator.js